import { z } from 'zod';
import {
    DEFAULT_FLEET_PORTAL_CLAIM_VIEW,
    type FleetPortalClaimViewConfiguration,
    PORTAL_CLAIM_VIEW_SECTIONS,
} from '../constants/business/fleet-portal';

/**
 * The stored shape of `fleet_portal_claim_view` (CUR-1069). Every section is
 * named so a partial object cannot silently switch a section on or off:
 * the editor writes the whole set, the server refuses anything else.
 */
export const fleetPortalClaimViewSchema = z
    .object({
        sections: z
            .object(
                Object.fromEntries(PORTAL_CLAIM_VIEW_SECTIONS.map((section) => [section, z.boolean()])) as Record<
                    (typeof PORTAL_CLAIM_VIEW_SECTIONS)[number],
                    z.ZodBoolean
                >,
            )
            .strict(),
    })
    .strict();

/** Parses a stored value; the shipped default when absent or unusable. */
export function parseFleetPortalClaimView(rawValue: string | null | undefined): FleetPortalClaimViewConfiguration {
    if (!rawValue) {
        return DEFAULT_FLEET_PORTAL_CLAIM_VIEW;
    }
    try {
        return fleetPortalClaimViewSchema.parse(JSON.parse(rawValue));
    } catch {
        return DEFAULT_FLEET_PORTAL_CLAIM_VIEW;
    }
}
